import AbstractService from "../../vendors/services/abstractService";
import { urlApi } from "../shared/apis/api";
import { TResponseApi } from "../../vendors/@types/httpApi";
import { AxiosResponse } from "axios";

export default class ContribuinteService extends AbstractService {
  constructor() {
    super(urlApi, "ManterContribuinte");
  }

  public async existeContribuinte(data: any): Promise<TResponseApi<any>> {
    return this.api.put(`${this.rota}/ExisteContribuinte`, data);
  }

  public obterTipoInteressado(idTipoPessoa: any) {
    return this.api.get(`${this.rota}/TipoInteressado/${idTipoPessoa}`);
  }

  public obterAreaInteresse(filter?: any) {
    const serialized = this.serialize(filter);
    return this.api.get(`${this.rota}/AreaInteresse?${serialized}`);
  }

  public obterUf() {
    return this.api.get(`${this.rota}/UF`);
  }

  public obterMunicipio(cdUf: any) {
    return this.api.get(`${this.rota}/Municipio/${cdUf}`);
  }

  public async verificarMembro(cpf: any) {
    return this.api.get(`/contribuintes/cpf/${cpf}`);
  }

  create(body: any): Promise<AxiosResponse<any>> {
    return this.api.post(`${this.rota}`, body);
  }

  public async updateMembro(data: any): Promise<TResponseApi<any>> {
    return this.api.put(`${this.rota}`, data);
  }
}
